module.exports = "<p>\r\n  rider-payor-grid works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/rider/components/rider-payor-grid/rider-payor-grid.component.html
// module id = 2517
// module chunks = 66